import { PermissionDto, PermissionsApi } from '../../../api-client';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { getApiConfiguration } from '../../../common';

const QUERY_KEY = 'permissions';

type UseGetPermissions = (
  options?: Omit<UseQueryOptions<PermissionDto[], ErrorResponse, PermissionDto[], string[]>,
    'queryKey' | 'queryFn'>,
) => UseQueryResult<PermissionDto[]>;

export const useGetPermissions: UseGetPermissions = (options) => {
  const permissionsApi = new PermissionsApi(getApiConfiguration());
  return useQuery(
    [QUERY_KEY],
    async () => permissionsApi.getPermissions().then((res) => res.data),
    options,
  );
};
